import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import { formatToAmount } from '@qrios/frontend-library';
import DetailsList from '../../../../../../common/details-list';
import locales from '../../../../../../../constants/locales';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { Operation } from './interfaces';

interface Props {
  operation: Operation;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details } = operation;

  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            {
              label: locales.operation.label.creditAccountNumber,
              value: details.creditAccount.accountNumber
            },
            { label: locales.operation.label.creditBank, value: details.creditAccount.bankName },
            {
              label: locales.operation.label.purpose,
              value: details.purpose
            },
            {
              label: locales.operation.label.amount,
              value: formatToAmount(operation.amount.value)
            },
            {
              label: locales.operation.label.externalTransactionId,
              value: details.externalTransactionId
            },
            {
              label: locales.operation.label.cost,
              value: formatToAmount(operation.cost.value)
            }
          ]}
        />
      }
    />
  );
};

export default SuccessOperation;
